import AxiosService from '../AxiosService';

const NESTOR_ENDPOINT = "/api/v1/data/nestor/summary"
const DOWNLOAD_ALL_ENDPOINT = "/api/v1/data/export/summary"

export default class DataSummaryService {

  constructor() {
    this.service = new AxiosService();
  }

  resolveNestorSummary() {
    return this.service.get(NESTOR_ENDPOINT);
  }

  resolveDownloadAllSummary() {
    return this.service.get(DOWNLOAD_ALL_ENDPOINT);
  }

}